/**
 * TierBadge — json-render web wrapper (verified P3.4a)
 *
 * Web implementation for the json-render catalog.
 * Visual spec: Sally (Discourse #3543/4) — Section 5
 *
 * Inspired by TierCard.tsx visual language. No direct RN equivalent exists
 * in packages/ui, so this remains a styled web wrapper. Gold accent (#C8A882)
 * for Drama+ and DramaX tiers matches the app's tier visual language.
 *
 * Task: [#1158.SDUI-M.P3.4a]
 * Agent: Diego <diego@liftping.net>
 */
"use client";

import React from "react";
import { cn } from "../../lib/utils";
import type { TierBadgeProps } from "../schema";

const tierConfig = {
  free: {
    defaultLabel: "Free",
    classes: "bg-muted text-muted-foreground border border-border",
  },
  drama_plus: {
    defaultLabel: "Drama+",
    classes: "bg-accent-blush text-accent-gold border border-[#C8A882]",
  },
  dramax: {
    defaultLabel: "DramaX",
    classes: "bg-black text-[#C8A882] border border-[#C8A882]",
  },
} as const;

export function TierBadge({ tier, label, showUpgradeHint = false }: TierBadgeProps) {
  const config = tierConfig[tier];
  const displayLabel = label ?? config.defaultLabel;

  return (
    <div className="inline-flex flex-col items-start gap-1">
      <span
        className={cn(
          "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
          config.classes
        )}
      >
        {displayLabel}
      </span>
      {showUpgradeHint && tier === "free" && (
        <span className="text-xs text-muted-foreground">
          Upgrade to unlock full access
        </span>
      )}
      {showUpgradeHint && tier === "drama_plus" && (
        <span className="text-xs text-[#C8A882]">
          Upgrade to DramaX for more
        </span>
      )}
    </div>
  );
}
